module.exports = __webpack_public_path__ + "media/images/flags/1x1/geo-732b3ad92717426c05ba2e0d9aa45507.svg";